import type { IDisclosureButtonProps, IOrientation } from '@sixui/ui';
import type { FieldValues, UseControllerProps } from 'react-hook-form';
import { Disclosure, DisclosureButton } from '@sixui/ui';
import { useController } from 'react-hook-form';

import { FormSection } from '~/components/atoms/FormSection';

// TODO: should live in a sixui-forms package

export type IFormCheckableDisclosureProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> &
    Omit<IDisclosureButtonProps, 'defaultChecked' | 'checked' | 'children'> & {
      children: React.ReactNode;
      label: string;
      expanded?: boolean;
      initiallyExpanded?: boolean;
      orientation?: IOrientation;
    };

// TODO: use FormField
export const FormCheckableDisclosure = <TFieldValues extends FieldValues>(
  props: IFormCheckableDisclosureProps<TFieldValues>,
): React.ReactNode => {
  const {
    sx,
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
    disabled,
    label,
    children,
    expanded,
    initiallyExpanded,
    orientation,
    ...other
  } = props;

  const { field } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
    disabled,
  });

  return (
    <Disclosure
      sx={sx}
      trigger={
        <DisclosureButton
          {...other}
          {...field}
          checked={!!field.value}
          checkable={!other.switchable}
        >
          {label}
        </DisclosureButton>
      }
      expanded={expanded}
      initiallyExpanded={initiallyExpanded}
      orientation={orientation}
    >
      <FormSection sub>{children}</FormSection>
    </Disclosure>
  );
};
